/**
 * WordPress Dependencies.
 */
import domReady from '@wordpress/dom-ready';
import { registerPlugin } from '@wordpress/plugins';
import { SelectControl } from '@wordpress/components';
import { PluginDocumentSettingPanel } from '@wordpress/edit-post';

import { __ } from '@wordpress/i18n';
import { useDispatch, useSelect } from '@wordpress/data';
import { get } from 'lodash';

domReady( () => {
	registerPlugin( 'cointokengate-connection', {
		render: () => {
			const metaKey = 'coingate-connection-gate';
			const successOutputTypeMetaKey = 'coingate-success-output-type';

			const {
				currentGateConnectionId,
				currentSuccessOutputType,
			} = useSelect( ( select ) => {
				const postMeta = select( 'core/editor' ).getEditedPostAttribute(
					'meta'
				);
				return {
					currentGateConnectionId:
						metaKey in postMeta ? postMeta[ metaKey ] : '',
					currentSuccessOutputType:
						successOutputTypeMetaKey in postMeta
							? postMeta[ successOutputTypeMetaKey ]
							: '',
				};
			} );

			const { editPost } = useDispatch( 'core/editor' );

			const handleGateConnectionChange = ( newConnectionId ) => {
				editPost( {
					meta: {
						[ metaKey ]: newConnectionId,
					},
				} );
			};

			const handleGateConnectionOutputTypeChange = (
				newConnectionOutputType
			) => {
				editPost( {
					meta: {
						[ successOutputTypeMetaKey ]: newConnectionOutputType,
					},
				} );
			};

			const availableConnections = get(
				window,
				'web3coingateConnections',
				[]
			);

			const finalConnections = [
				{
					value: -1,
					label: __( 'Select Connection', 'web3-coin-gate' ),
				},
				...availableConnections,
			];

			const successOutputOptions = [
				{
					value: 'page-content',
					label: __( 'Current Page Content', 'web3-coin-gate' ),
				},
				{
					value: 'connection-content',
					label: __( 'Connection Success Output', 'web3-coin-gate' ),
				},
			];

			return (
				<PluginDocumentSettingPanel
					icon={ () => null }
					title={ __( 'Web3 Coin Gate', 'web3-coin-gate' ) }
					name="wptokengate-token-gate-connection"
				>
					<SelectControl
						label={ __(
							'Select Connection Gate',
							'web3-coin-gate'
						) }
						options={ finalConnections }
						value={ currentGateConnectionId }
						onChange={ handleGateConnectionChange }
					/>
					<br />
					<SelectControl
						label={ __(
							'Select Success Output Type',
							'web3-coin-gate'
						) }
						help={ __(
							'Output that will be displayed when the token is valid',
							'web3-coin-gate'
						) }
						options={ successOutputOptions }
						value={ currentSuccessOutputType }
						onChange={ handleGateConnectionOutputTypeChange }
					/>
				</PluginDocumentSettingPanel>
			);
		},
	} );
} );
